"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var TeachingBubbleContent_1 = require("./TeachingBubbleContent");
var Callout_1 = require("../../Callout");
var stylesImport = require("./TeachingBubble.scss");
var styles = stylesImport;
var TeachingBubble = /** @class */ (function (_super) {
    tslib_1.__extends(TeachingBubble, _super);
    // Constructor
    function TeachingBubble(props) {
        var _this = _super.call(this, props) || this;
        _this.rootElement = Utilities_1.createRef();
        _this.state = {};
        _this._defaultCalloutProps = {
            beakWidth: 16,
            gapSpace: 0,
            setInitialFocus: true,
            doNotLayer: false,
            directionalHint: 12 /* rightCenter */
        };
        return _this;
    }
    TeachingBubble.prototype.focus = function () {
        if (this.rootElement.current) {
            this.rootElement.current.focus();
        }
    };
    TeachingBubble.prototype.render = function () {
        var _a = this.props, setCalloutProps = _a.calloutProps, targetElement = _a.targetElement, onDismiss = _a.onDismiss, isWide = _a.isWide;
        var calloutProps = tslib_1.__assign({}, this._defaultCalloutProps, setCalloutProps);
        return (React.createElement(Callout_1.Callout, tslib_1.__assign({ target: targetElement, onDismiss: onDismiss }, calloutProps, { className: Utilities_1.css('ms-TeachingBubble', styles.root, isWide ? styles.wideCallout : null, calloutProps ? calloutProps.className : undefined) }),
            React.createElement("div", { ref: this.rootElement },
                React.createElement(TeachingBubbleContent_1.TeachingBubbleContent, tslib_1.__assign({}, this.props)))));
    };
    TeachingBubble.defaultProps = {
        /**
         * Default calloutProps is deprecated in favor of private _defaultCalloutProps.
         * Remove in next release.
         * @deprecated
         */
        calloutProps: {
            beakWidth: 16,
            gapSpace: 0,
            setInitialFocus: true,
            doNotLayer: false,
            directionalHint: 12 /* rightCenter */
        }
    };
    return TeachingBubble;
}(Utilities_1.BaseComponent));
exports.TeachingBubble = TeachingBubble;
//# sourceMappingURL=TeachingBubble.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/TeachingBubble/TeachingBubble.js
// module id = 1682
// module chunks = 0